// Puzzle configuration
// Grid is always 4x4 for both mobile and desktop
export const GRID_SIZE_DESKTOP = 4;
export const GRID_SIZE_MOBILE = 4;
// Default grid size (used for non-dynamic contexts)
export const GRID_SIZE = GRID_SIZE_MOBILE;
export const TOTAL_PIECES = GRID_SIZE * GRID_SIZE;

// App mode indicator
export const APP_MODE = 'responsive'; // Supports both mobile and desktop

// Mobile viewport constraints (Android optimization)
export const MAX_MOBILE_WIDTH = 351;
export const MAX_MOBILE_HEIGHT = 800;

// Tablet viewport constraints (iPad / Android tablets) — set very high caps
// so the puzzle is allowed to scale up to fill iPad-class screens. Piece size
// itself is the real limit (TABLET_PIECE_SIZE) so the puzzle never grows
// absurdly large on a 12.9" iPad Pro.
export const MAX_TABLET_WIDTH = 1400;
export const MAX_TABLET_HEIGHT = 1400;
export const TABLET_PIECE_SIZE = 140;

// Desktop layout constants
export const DESKTOP_MIN_WIDTH = 1024; // lg breakpoint
export const DESKTOP_PIECE_SIZE = 90; // Larger pieces for desktop

// Helper to get pieces count for a grid size
export const getPiecesCount = (gridSize) => gridSize * gridSize;

// Difficulty settings
export const DIFFICULTIES = {
  easy: {
    name: 'Easy',
    multiplier: 0.75,
    showHint: true,
    hintOpacity: 0.35,
    rotatesPieces: false,
    perfectBonus: 25,
    badge: 'E',
    color: 'success'
  },
  normal: {
    name: 'Normal',
    multiplier: 1.0,
    showHint: false,
    hintOpacity: 0,
    rotatesPieces: false,
    perfectBonus: 50,
    badge: 'N',
    color: 'primary'
  },
  hard: {
    name: 'Hard',
    multiplier: 1.5,
    showHint: false,
    hintOpacity: 0,
    rotatesPieces: true,
    perfectBonus: 100,
    badge: 'H',
    color: 'destructive'
  }
};

// Theme settings
export const THEMES = {
  default: {
    name: 'Cream & Blue',
    icon: '☀️'
  },
  ocean: {
    name: 'Ocean',
    icon: '🌊'
  },
  forest: {
    name: 'Forest',
    icon: '🌲'
  },
  sunset: {
    name: 'Sunset',
    icon: '🌅'
  }
};

// NOTE: Puzzle images are now fetched from the backend API
// Endpoints: /api/images/random (for random play) and /api/images/list (for navigation)

// Scoring formula constants
export const SCORING = {
  TIME_BASE: 500,
  TIME_DECAY: 120,
  MOVE_BASE: 300,
  COMPLETION_BONUS: 200
};
